import React from 'react';

import Admin from 'hive-admin';

import tests from '../../helpers/tests';

import Types from '../../modules/types';

// import { IconDelete } from '../../components/ActionDelete';

// import { createChangeLogSection } from '../../components/FieldChangeLog';

import {
  ADMIN_ALL as FILTERS_ADMIN_ALL,
} from './filters';

import {
  ADMIN_ALL as COLUMNS_ADMIN_ALL,
} from './columns';

const {
  viewerIsAdmin,
  viewerIsNotAdmin,
  viewerIsUserOwner,
  viewerIsNotUserOwner,
  // activityIsNotEdit,
  // activityIsNotCreate,
} = tests;

const showPassword = ({ data, viewer, activity }) => (
  process.env.REACT_APP_DXTOOLS_ENV === 'development'
  || (
    activity === 'create'
  )
  || (
    /@thehive.rs$/.test(viewer?.email || '')
  )
  || (
    (data?._id || 0) === (viewer?._id || 1)
  )
);

const skipPassword = [
  'condition.not',
  showPassword,
];

const isNotCreateActivity = ['condition.check', {
  path1: 'activity',
  op: '!==',
  value2: 'create',
}];

export default (
  Admin.compileFromLibrary(['GroupResource', {
    title: 'Users',
    // icon: 'user',
    path: '/users',
    hidden: [viewerIsNotAdmin],
    redirect: [['redirect.unauthorized']],
    archiveConfig: {
      icon: 'user',
      title: 'Users',
      label: 'Users',
      // icon: 'user',
      createButtonPath: '/users/create',
      subtitleColumnPath: 'email',
      filters: FILTERS_ADMIN_ALL,
      columns: COLUMNS_ADMIN_ALL,
      skip: [viewerIsNotAdmin],
      hidden: [viewerIsNotAdmin],
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', 'ADMIN',
          '/users/me',
        ],
      ],
    },
    singleConfig: {
      hidden: true,
      alias: '/users',
      headerTitle: 'Create',
      backButtonLabel: 'Close',
      backButtonPaths: ['/users'],
    },
    singleCreateConfig: {
      hidden: true,
    },
    singleEditConfig: {
      getBackButtonPaths: props => (
          props.viewer && props.viewer.role === 'ADMIN'
        ? props.backButtonPaths
        : false
      ),
      hidden: true,
      actions: [
        ['ActionSave'],
        ['ActionDelete', {
          skip: [
            viewerIsNotAdmin,
          ],
        }],
        ['ActionWithRequest', {
          name: 'activate',
          title: 'Activate',
          skip: [
            ['condition.check', { path1: 'data.active', value2: true }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/activate?id=${props.data._id}`,
            method: 'POST',
          }),
          handleSuccess: (data, props) => props.reload(),
        }],
        ['ActionWithRequest', {
          name: 'deactivate',
          title: 'Deactivate',
          type: 'danger',
          ghost: true,
          skip: [
            ['condition.check', { path1: 'viewer._id', path2: 'data._id' }],
            viewerIsNotAdmin,
            ['condition.check', { path1: 'data.active', value2: false }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/deactivate?id=${props.data._id}`,
            method: 'POST',
          }),
          handleSuccess: (data, props) => props.reload(),
        }],
        ['ActionWithRequest', {
          name: 'send-activation-email',
          title: 'Send Activation Email',
          skip: [
            ['condition.check', { path1: 'data.active', value2: true }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/activate?id=${props.data._id}&email=true`,
            method: 'POST',
          }),
        }],
        ['ActionWithRequest', {
          name: 'logout-elsewhere',
          title: 'Logout Other Devices',
          type: 'danger',
          ghost: true,
          skip: [
            viewerIsNotUserOwner,
            ['condition.check', { path1: 'data.active', value2: false }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/logout-elsewhere?id=${
              props.data._id
            }`,
            method: 'POST',
          }),
          // eslint-disable-next-line no-unused-vars
          getMessageSuccess: (data, props) => (
            data.count === 0
            ? 'Not logged in anywhere else!'
            : `Logged out of ${data.count} ${
              data.count > 1
              ? 'devices'
              : 'device'
            }!`
          ),
        }],
        ['ActionWithRequest', {
          name: 'logout-everywhere',
          title: 'Logout Everywhere',
          type: 'danger',
          ghost: true,
          skip: [
            viewerIsNotAdmin,
            viewerIsUserOwner,
            ['condition.check', { path1: 'data.active', value2: false }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/logout-elsewhere?id=${
              props.data._id
            }`,
            method: 'POST',
          }),
          // eslint-disable-next-line no-unused-vars
          getMessageSuccess: (data, props) => (
            data.count === 0
            ? 'Not logged in anywhere!'
            : `Logged out of ${data.count} ${
              data.count > 1
              ? 'devices'
              : 'device'
            }!`
          ),
        }],
      ],
    },
    fields: [
      ['FieldText', {
        name: 'name',
        label: 'Name',
        rules: [['validation.isRequired'], ['validation.isName']],
      }],
      ['FieldText', {
        name: 'email',
        autoComplete: 'new-email',
        rules: [['validation.isRequired'], ['validation.isEmail']],
      }],
      ['FieldSelect', {
        name: 'role',
        label: 'Role',
        rules: [['validation.isRequired']],
        choices: Types.ROLE,
        initialValue: 'ADMIN',
        disabled: [isNotCreateActivity],
        virtual: [isNotCreateActivity],
        skip: [viewerIsNotAdmin],
      }],
      ['Divider', {
        name: 'passwordDivider',
        skip: [skipPassword],
      }],
      ['FieldText', {
        name: 'password',
        type: 'password',
        label: 'Password',
        autoComplete: 'new-password',
        rules: [
          ['validation.isPassword'],
        ],
        skip: [skipPassword],
      }],
      ['FieldText', {
        name: 'confirmPassword',
        type: 'password',
        label: 'Confirm Password',
        rules: [
          ['validation.isPasswordSame'],
        ],
        skip: [skipPassword],
        virtual: true,
      }],
      // ...createChangeLogSection({
      //   changeLogConfig: {
      //     getWhereConditions: props => ({
      //       'author.type': 'User',
      //       'author.subject': props.data._id,
      //     }),
      //     skipColumns: {
      //       author: true,
      //     },
      //   },
      // }),
    ],
  }])
).pages;
